<template>
  <div class="Female">
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 72 72">
      <path
        d="M62.31,36A26.31,26.31,0,1,0,34,62.23v2.4H30v4h4v2.65h4V68.63h4v-4H38v-2.4A26.34,26.34,0,0,0,62.31,36ZM13.69,36A22.31,22.31,0,1,1,36,58.31,22.34,22.34,0,0,1,13.69,36Z"
        fill="#ef4266" />
      <text
        xml:space="preserve"
        style="
          font-style: normal;
          font-weight: normal;
          font-size: 21.1355px;
          line-height: 1.25;
          font-family: sans-serif;
          fill: #000000;
          fill-opacity: 1;
          stroke: none;
          stroke-width: 0.528389;
        "
        x="28.410883"
        y="38.110516"
        id="text66"
        transform="scale(0.90842243,1.1008095)">
        <tspan
          sodipodi:role="line"
          id="tspan64"
          x="28.410883"
          y="38.110516"
          style="stroke-width: 0.528389;">
          {{ age }}
        </tspan>
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  props: {
    age: {
      type: Number,
      default: 0,
    },
  },
  mounted() {},

  methods: {},

  computed: {},

  filters: {},
};
</script>

<style lang="scss" scoped>
.Female {
}
</style>
